/**
 *
 * Asynchronously loads the component for TeamGroupList
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
